// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"91034651","450":"7259fb4f"}[chunkId] + ".chunk.js";
};